import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{attrs:{"lang":_vm.lang.langname,"id":"inspire"}},[(_vm.$route.meta.portal)?_c('MobilePortalShell',[_c('router-view')],1):[_c(VMain,{style:("direction:"+_vm.lang.dir)},[_c('router-view')],1),_c('FloatButton',{directives:[{name:"show",rawName:"v-show",value:(!_vm.withsidemenu),expression:"!withsidemenu"}]}),_c('License')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }